// @flow

import { ApiService } from './api-service';
import authService from './auth-service';
import { checkAuth } from '../actions/auth';
import store from '../store';

type Headers = {
  'Content-Type': string,
  Authorization?: string,
}

export class AuthApiService extends ApiService {
  get headers(): Headers {
    const headers = {
      ...super.headers
    };
    headers['Content-Type'] = 'application/json';
    headers.Authorization = `Bearer ${authService.token || ''}`;
    return headers;
  }

  handleError(error: any): Promise<string> {
    const errors = error.response;
    if (errors && errors.data && errors.data.error && errors.data.error.statusCode === 401) {
      return store.dispatch(checkAuth());
    }
    return super.handleError(error);
  }
}

export default new AuthApiService();



// WEBPACK FOOTER //
// ./src/services/auth-api-service.js